import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      {/* Newsletter Section */}
      <div className="newsletter-section">
        <div className="newsletter-content">
          <div className="newsletter-left">
            <h2>Don't miss out!</h2>
            <p>shop@bernicemy.blog</p>
            <p>Flat 11 The Abode, Halifax, West Yorkshire, HX1 5AF</p>
          </div>
          <div className="newsletter-right">
            <div className="story-card">
              <img src="/main/main1.webp" alt="The Modern Southern Studio" />
              <div className="story-overlay">
                <h3>The Modern Southern Studio</h3>
                <Link to="/about" onClick={toTop}>
                  READ THE STORY
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Links Section */}
      <div className="footer-links">
        <div className="footer-column">
          <h4>Support</h4>
          <ul>
            <li>
              <Link to="/contact" onClick={toTop}>
                Customer Support
              </Link>
            </li>

            <li>
              <Link to="/returns" onClick={toTop}>
                Returns + Exchanges
              </Link>
            </li>
            <li>
              <Link to="/shipping" onClick={toTop}>
                Shipping
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>About Us</h4>
          <ul>
            <li>
              <Link to="/about" onClick={toTop}>
                The Bernicemy Story
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Follow Us</h4>
          <ul>
            <li>
              <Link
                to="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </Link>
            </li>
            <li>
              <Link
                to="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </Link>
            </li>
            <li>
              <Link
                to="https://tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Tik Tok
              </Link>
            </li>
            <li>
              <Link to="/" onClick={toTop}>
                Influencer & Affiliate
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="footer-bottom">
        <div className="footer-legal">
          <Link to="/terms" onClick={toTop}>
            Terms of Use
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy Policy
          </Link>
        </div>
        <div className="footer-copyright">
          <p>© 2025 Bernicemy</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
